// "Move all of this week's visits to next week" (WEEK-PANEL-NEXT-4 item C):
// nobody is rostered this week, so every booked visit in the week on screen
// slides seven days in one go instead of row by row. The pure half lives here
// — which visits move and where each one lands — so the date rule can be
// pinned by a test without a browser.

import type { Clean } from './types'
import { isContact } from './planning'
import { addDaysISO, todayISO } from './ui'

// "Next week" has to mean a week that has not happened yet. Seven days after
// a due date works for someone due soon and lands in the PAST for someone
// already late — Late Larry, due 8 Sep, was booked onto 15 Sep when today was
// the 17th (caught verifying, 2026-09-17). Step forward in whole weeks until
// the date is today or later, so the weekday the caller wanted is kept.
// (Moved here from schedule.ts so the week move and the row menu share the
// one definition, WEEK-PANEL-NEXT-4 item C.)
export function nextWeekFrom(iso: string, today: string = todayISO()): string {
  let d = addDaysISO(iso, 7)
  while (d < today) d = addDaysISO(d, 7)
  return d
}

export interface WeekMove {
  id: number
  from: string
  to: string
}

// Which visits the week move takes with it: booked, dated inside the week on
// screen, not a contact reminder (isContact — those are prompts to get in
// touch, not work anyone expects on the day). Suggestions and pencilled
// visits move with the rest — they are the app's guess, and next week's guess
// is as good. Cancelled and done fail state === 'booked'. Oldest first, then
// by id, so the queue and any report read in diary order.
export function weekMoveSet(cleans: Clean[], from: string, to: string, today: string = todayISO()): WeekMove[] {
  return cleans
    .filter(cl => cl.date >= from && cl.date <= to && cl.state === 'booked' && !isContact(cl))
    .sort((a, b) => a.date.localeCompare(b.date) || a.id - b.id)
    .map(cl => ({ id: cl.id, from: cl.date, to: nextWeekFrom(cl.date, today) }))
}
